import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d32f9b7")

_pushScopeId("data-v-5d32f9b7")
const _hoisted_1 = { class: "flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "font-32 el-icon-loading"
}
const _hoisted_3 = { class: "flex align-center" }
const _hoisted_4 = {
  key: 0,
  class: "font-32 el-icon-loading"
}
const _hoisted_5 = { class: "flex-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "创建菜单",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "40%"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formDom",
        model: _ctx.formData,
        "label-width": "180px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            required: "",
            prop: "name",
            rules: [{
                      required: true, message: '菜单名称不能为空'
                    }],
            label: "菜单名称"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                type: "input",
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "sortNumber",
            label: "排序"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.formData.sortNumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.sortNumber = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "lightIcon",
            rules: [{ required: true,message: '请上传浅色图标',trigger: 'blur' }],
            label: "浅色图标"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                (_ctx.formData.lightIcon)
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      class: "icon",
                      src: _ctx.formData.lightIcon
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_upload, {
                  action: _ctx.fileUploadPath,
                  headers: _ctx.tokenHeader,
                  "on-success": _ctx.handleLightIconUploaded,
                  "on-error": _ctx.handleLightIconUploadError,
                  "before-upload": _ctx.beforeLightIconUpload,
                  "show-file-list": false,
                  accept: "image/*"
                }, {
                  default: _withId(() => [
                    (_ctx.showLightIconUploading)
                      ? (_openBlock(), _createBlock("i", _hoisted_2))
                      : _createCommentVNode("", true),
                    (!_ctx.showLightIconUploading)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          class: "margin-left-10",
                          type: "info",
                          i: "el-icon-plus"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(!!_ctx.formData.lightIcon ? '更换' : '上传') + "浅色图标", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["action", "headers", "on-success", "on-error", "before-upload"]),
                _createVNode(_component_el_input, {
                  class: "w-0",
                  type: "hidden",
                  modelValue: _ctx.formData.lightIcon,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.lightIcon = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "darkIcon",
            rules: [{ required: true,message: '请上传深色图标',trigger: 'blur' }],
            label: "深色图标"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_3, [
                (_ctx.formData.darkIcon)
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      class: "icon",
                      src: _ctx.formData.darkIcon
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_upload, {
                  action: _ctx.fileUploadPath,
                  headers: _ctx.tokenHeader,
                  "on-success": _ctx.handleDarkIconUploaded,
                  "on-error": _ctx.handleDarkIconUploadError,
                  "before-upload": _ctx.beforeDarkIconUpload,
                  "show-file-list": false,
                  accept: "image/*"
                }, {
                  default: _withId(() => [
                    (_ctx.showDarkIconUploading)
                      ? (_openBlock(), _createBlock("i", _hoisted_4))
                      : _createCommentVNode("", true),
                    (!_ctx.showDarkIconUploading)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          class: "margin-left-10",
                          type: "info",
                          i: "el-icon-plus"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(!!_ctx.formData.darkIcon ? '更换' : '上传') + "深色图标", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["action", "headers", "on-success", "on-error", "before-upload"]),
                _createVNode(_component_el_input, {
                  class: "w-0",
                  type: "hidden",
                  modelValue: _ctx.formData.darkIcon,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.darkIcon = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: _ctx.submit
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})